var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98018 17.9179C2.35277 18.5451 2.00019 19.3958 2 20.283V22H3.71699C4.60415 21.9998 5.45491 21.6472 6.08214 21.0198L17.2413 9.86063L14.1394 6.75868L2.98018 17.9179Z",
    fill: "#2A313C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3569 2.64308C21.1533 2.43922 20.9114 2.27749 20.6452 2.16714C20.379 2.0568 20.0937 2 19.8055 2C19.5174 2 19.232 2.0568 18.9658 2.16714C18.6996 2.27749 18.4578 2.43922 18.2541 2.64308L15.3219 5.5761L18.4239 8.67806L21.3569 5.74588C21.5608 5.54222 21.7225 5.30038 21.8329 5.03418C21.9432 4.76798 22 4.48264 22 4.19448C22 3.90632 21.9432 3.62098 21.8329 3.35478C21.7225 3.08858 21.5608 2.84674 21.3569 2.64308Z",
    fill: "#2A313C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.599f2314aa89b900d2fb30390856563a.svg";
export { ForwardRef as ReactComponent };